import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '@/redux/Store';
import { fetchPostById } from '@/redux/thunks/postThunks';
import { clearCurrentPost } from '@/redux/slices/postSlice';
import { LoadingSpinner } from '@/components';
import { PostCard } from '@/components/Post';
import { recordShareClickIfPresent, stripTrkrFromUrl } from '@/utils/shareLink';
import './page.scss';

export default function PostDetailPage() {
  const { postId } = useParams<{ postId: string }>();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const post = useAppSelector((state) => state.post.currentPost);
  const isLoading = useAppSelector((state) => state.post.isLoading);
  const error = useAppSelector((state) => state.post.error);

  useEffect(() => {
    if (!postId) {
      navigate('/');
      return;
    }

    // Land at the top of the post, not wherever the feed was scrolled.
    window.scrollTo({ top: 0, behavior: 'auto' });

    dispatch(fetchPostById(postId));

    return () => {
      dispatch(clearCurrentPost());
    };
  }, [postId, dispatch, navigate]);

  // Record share click + strip ?trkr= on mount (#256). Fire and forget.
  useEffect(() => {
    recordShareClickIfPresent().finally(stripTrkrFromUrl);
  }, []);

  if (isLoading) {
    return (
      <div className="post-detail-page">
        <LoadingSpinner size="medium" message="Loading post..." fullHeight />
      </div>
    );
  }

  if (error || !post) {
    return (
      <div className="post-detail-page">
        <div className="post-detail-error">
          <h2>Oops!</h2>
          <p>{error || 'Post not found'}</p>
          <button onClick={() => navigate('/')} className="btn btn-primary">
            Go home
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="post-detail-page">
      <div className="post-detail-container">
        <button onClick={() => navigate(-1)} className="back-button">
          ← Back
        </button>

        <PostCard post={post} />
      </div>
    </div>
  );
}
